/* global Foundation  */
import $ from 'jquery'
import Vue from 'vue'
export default Vue.extend({
  name: 'joi-form-error-callout',
  template: '<div class="alert callout form-error" data-closable data-error-for-form role="error-information">' +
    '<p>{{message}}</p>' +
    '<button class="close-button" aria-label="Dismiss alert" type="button" data-close>' +
      '<span aria-hidden="true">&times;</span>' +
    '</button>' +
  '</div>',
  props: ['for', 'path', 'message'],
  isFormError: true,
  data () {
    return {
    }
  },
  methods: {
    show: function () {
      Foundation.Motion.animateIn(this.$el, 'fade-in')
    },
    hide: function () {
      $(this.$el).hide()
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/inputs/joi-form-error-callout.js